import { DashboardRouter } from "../dashboard.router";

export class PatientRecordsRouter {
    
    static getRoute(): string {
        return `${DashboardRouter.getRoute()}/patient-records`
    }

}